export default __webpack_public_path__ + "static/media/Fcw.3b877958.png";